module.exports = __webpack_public_path__ + "static/media/Vehicle-Icon.d8359d68.svg";